export const ORGANIZATION_QUERY_KEYS = {
    current: ['org', 'current'] as const,
    all: ['org', 'all'] as const,
    businessHours: ['org', 'business-hours'] as const,
    quietHours: ['org', 'quiet-hours'] as const,
} as const;

export const CURRENCIES: { code: string; label: string; symbol: string }[] = [
    { code: 'USD', label: 'US Dollar (USD)', symbol: '$' },
    { code: 'EUR', label: 'Euro (EUR)', symbol: '€' },
    { code: 'GBP', label: 'British Pound (GBP)', symbol: '£' },
    { code: 'INR', label: 'Indian Rupee (INR)', symbol: '₹' },
    { code: 'CAD', label: 'Canadian Dollar (CAD)', symbol: 'CA$' },
    { code: 'AUD', label: 'Australian Dollar (AUD)', symbol: 'A$' },
    { code: 'SGD', label: 'Singapore Dollar (SGD)', symbol: 'S$' },
    { code: 'AED', label: 'UAE Dirham (AED)', symbol: 'AED' },
    { code: 'JPY', label: 'Japanese Yen (JPY)', symbol: '¥' },
    { code: 'CNY', label: 'Chinese Yuan (CNY)', symbol: '¥' },
    { code: 'BRL', label: 'Brazilian Real (BRL)', symbol: 'R$' },
    { code: 'MXN', label: 'Mexican Peso (MXN)', symbol: 'MX$' },
    { code: 'ZAR', label: 'South African Rand (ZAR)', symbol: 'R' },
    { code: 'NGN', label: 'Nigerian Naira (NGN)', symbol: '₦' },
    { code: 'KES', label: 'Kenyan Shilling (KES)', symbol: 'KSh' },
    { code: 'CHF', label: 'Swiss Franc (CHF)', symbol: 'CHF' },
    { code: 'SEK', label: 'Swedish Krona (SEK)', symbol: 'kr' },
    { code: 'NOK', label: 'Norwegian Krone (NOK)', symbol: 'kr' },
    { code: 'DKK', label: 'Danish Krone (DKK)', symbol: 'kr' },
    { code: 'NZD', label: 'New Zealand Dollar (NZD)', symbol: 'NZ$' },
];

export const COUNTRY_CURRENCY_MAP: Record<string, string> = {
    US: 'USD',
    GB: 'GBP',
    IN: 'INR',
    EU: 'EUR',
    DE: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    ES: 'EUR',
    NL: 'EUR',
    CA: 'CAD',
    AU: 'AUD',
    SG: 'SGD',
    AE: 'AED',
    JP: 'JPY',
    CN: 'CNY',
    BR: 'BRL',
    MX: 'MXN',
    ZA: 'ZAR',
    NG: 'NGN',
    KE: 'KES',
    CH: 'CHF',
    SE: 'SEK',
    NO: 'NOK',
    DK: 'DKK',
    NZ: 'NZD',
};

export const ALLOWED_LOGO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const MAX_LOGO_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

/** Maps ISO 4217 currency code → ISO 3166-1 alpha-2 country code (lowercase) for flag display */
export const CURRENCY_COUNTRY_MAP: Record<string, string> = {
    USD: 'us',
    GBP: 'gb',
    INR: 'in',
    CAD: 'ca',
    AUD: 'au',
    SGD: 'sg',
    AED: 'ae',
    JPY: 'jp',
    CNY: 'cn',
    BRL: 'br',
    MXN: 'mx',
    ZAR: 'za',
    NGN: 'ng',
    KES: 'ke',
    CHF: 'ch',
    SEK: 'se',
    NOK: 'no',
    DKK: 'dk',
    NZD: 'nz',
    EUR: 'eu',
};
